import { configureStore } from "@reduxjs/toolkit";
import {
  createPasswordApi,
  generateOtpApi,
  onboardingApi,
  resumeApi,
  selectApi,
  servicesApi,
  statusApi,
} from "../api";
import { onfidoApi } from "../features/onfido/api";
import { onfidoSlice } from "../features/onfido/reducer";
import { onboardingSlice } from "../features/onboarding/onboarding.slice";
import uiSlice from "../features/ui/ui.slice";
import resumeSlice from "../features/resume/resume.slice";
import { gtmMiddleware } from "../features/analytics/beacon.config";
import { statusSlice } from "../features/status";
import { createPasswordSlice } from "../features";
import { errorOverridesMiddleware } from "./errorOverridesMiddleware";

export const rootStore = configureStore({
  reducer: {
    onboarding: onboardingSlice.reducer,
    createPassword: createPasswordSlice.reducer,
    status: statusSlice.reducer,
    ui: uiSlice.reducer,
    resume: resumeSlice.reducer,
    onfido: onfidoSlice.reducer,
    [onboardingApi.reducerPath]: onboardingApi.reducer,
    [createPasswordApi.reducerPath]: createPasswordApi.reducer,
    [statusApi.reducerPath]: statusApi.reducer,
    [resumeApi.reducerPath]: resumeApi.reducer,
    [servicesApi.reducerPath]: servicesApi.reducer,
    [selectApi.reducerPath]: selectApi.reducer,
    [onfidoApi.reducerPath]: onfidoApi.reducer,
    [generateOtpApi.reducerPath]: generateOtpApi.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .prepend(errorOverridesMiddleware)
      .concat(
        onboardingApi.middleware,
        createPasswordApi.middleware,
        statusApi.middleware,
        resumeApi.middleware,
        servicesApi.middleware,
        selectApi.middleware,
        onfidoApi.middleware,
        generateOtpApi.middleware,
        gtmMiddleware,
      ),
  devTools: { name: "HYPE-ONBOARDING-STORE" },
});

export type RootState = ReturnType<typeof rootStore.getState>;
export type AppDispatch = typeof rootStore.dispatch;

export const getRootStore = () => rootStore;

export default rootStore;
